"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

require("./index.css");

var RadioGroup = function (_a) {
  var _b = _a.field,
      field = _b === void 0 ? {
    name: 'input',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange: function () {}
  } : _b,
      _c = _a.options,
      options = _c === void 0 ? [] : _c,
      _d = _a.label,
      label = _d === void 0 ? '' : _d,
      _e = _a.direction,
      direction = _e === void 0 ? 'column' : _e,
      className = _a.className,
      props = __rest(_a, ["field", "options", "label", "direction", "className"]);

  var directionVal = ['column', 'row'].indexOf(direction) >= 0 ? direction : 'column';
  var containerClass = "radio-group direction-" + directionVal;

  if (className) {
    containerClass += " " + className;
  }

  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [label && (0, jsx_runtime_1.jsx)("div", __assign({
      className: "radio-group-label",
      "data-testid": "radio-group-label-" + field.name
    }, {
      children: label
    }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({
      className: containerClass,
      "data-testid": "radio-group-" + field.name
    }, {
      children: options.map(function (option) {
        var optValue = "" + option.value;
        return (0, jsx_runtime_1.jsxs)("label", __assign({
          className: "radio-label",
          "data-testid": "radio-button-label-" + field.name,
          htmlFor: field.name + "-" + option.value
        }, {
          children: [(0, jsx_runtime_1.jsx)("input", __assign({
            name: field.name,
            id: field.name + "-" + option.value,
            onBlur: field.onChange,
            onChange: field.onChange,
            value: optValue,
            checked: optValue === field.value,
            "data-testid": "radio-button-" + field.name,
            className: "radio-button",
            type: "radio"
          }, props), void 0), (0, jsx_runtime_1.jsx)("span", __assign({
            className: "radio-label-text"
          }, {
            children: option.label
          }), void 0)]
        }), option.key || option.label);
      })
    }), void 0)]
  }, void 0);
};

exports.default = RadioGroup;